<template>
    <vs-popup class="holamundo info-modal" title="Are you sure?" :active.sync="popupActive">
        <div v-if="infoText">
            {{infoText}}
        </div>
        <div style="justify-content: flex-end; display: flex;">
            <vs-button class="mt-4 mr-2 shadow-lg" type="gradient" @click="() => { this.popupActive = false; this.isAction = true; }">Yes</vs-button>
            <vs-button class="mt-4 mr-2 shadow-lg" type="gradient" @click="() => { this.popupActive = false;}">No</vs-button>
        </div>
    </vs-popup>
</template>

<script>
    export default{
        props: {
            text: String,
        },
        data () {
            return {
                popupActive: true,
                isAction: false,
                infoText: 'Are you sure want delete this item?'
            }
        },
        computed: {

        },
        mounted () {
            this.popupActive = true;
            if (this.text) {
                this.infoText = this.text;
            }
        },
        created () {

        },
        watch: {
            popupActive() {
                if (!this.popupActive) {
                    this.closeModal();
                }
            }
        },
        methods: {
            closeModal() {
                setTimeout(() => {
                    this.$emit('closeInfo', this.isAction);
                }, 1)
            },

        }
    }
</script>
